import React from 'react';
export var EditorContext = /*#__PURE__*/React.createContext({});